var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-select',{class:{ filter: _vm.isFilter },attrs:{"label":_vm.label,"value":_vm.accessLevel,"options":_vm.options,"placeholder":_vm.placeholder,"hasError":_vm.hasError,"error":_vm.error,"disabled":_vm.disabled},on:{"select":function($event){return _vm.$emit('select', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }